import React from 'react';

var BLOCK_TAGS = {
  h1: 'heading-1',
  h2: 'heading-2',
  h3: 'heading-3',
  h4: 'heading-4',
  blockquote: 'block-quote',
  p: 'paragraph',
  pre: 'code',
  ol: 'numbered-list',
  ul: 'bulleted-list',
  li: 'list-item'

  // Add a dictionary of mark tags.
};var MARK_TAGS = {
  em: 'italic',
  strong: 'bold',
  del: 'delete',
  u: 'underline',
  code: 'code'
};

var rules = [{
  deserialize: function deserialize(el, next) {
    var type = BLOCK_TAGS[el.tagName.toLowerCase()];
    if (type) {
      return {
        object: 'block',
        type: type,
        data: {
          className: el.getAttribute('class')
        },
        nodes: next(el.childNodes)
      };
    }
  },
  serialize: function serialize(obj, children) {
    if (obj.object == 'block') {
      switch (obj.type) {
        case 'code':
          return React.createElement(
            'pre',
            null,
            React.createElement(
              'code',
              null,
              children
            )
          );
        case 'heading-1':
          return React.createElement(
            'h1',
            { className: obj.data.get('className') },
            children
          );
        case 'heading-2':
          return React.createElement(
            'h2',
            { className: obj.data.get('className') },
            children
          );
        case 'heading-3':
          return React.createElement(
            'h3',
            { className: obj.data.get('className') },
            children
          );
        case 'heading-4':
          return React.createElement(
            'h4',
            { className: obj.data.get('className') },
            children
          );
        case 'heading-5':
          return React.createElement(
            'h5',
            { className: obj.data.get('className') },
            children
          );
        case 'heading-6':
          return React.createElement(
            'h6',
            { className: obj.data.get('className') },
            children
          );
        case 'paragraph':
          return React.createElement(
            'p',
            { className: obj.data.get('className') },
            children
          );
        case 'block-quote':
          return React.createElement(
            'blockquote',
            null,
            children
          );
        case 'numbered-list':
          return React.createElement(
            'ol',
            null,
            children
          );
        case 'bulleted-list':
          return React.createElement(
            'ul',
            null,
            children
          );
        case 'list-item':
          return React.createElement(
            'li',
            null,
            children
          );
        case 'paragraph':
          return React.createElement(
            'p',
            null,
            children
          );
      }
    }
  }
},

// Add a new rule that handles marks...
{
  deserialize: function deserialize(el, next) {
    var type = MARK_TAGS[el.tagName.toLowerCase()];
    if (type) {
      return {
        object: 'mark',
        type: type,
        nodes: next(el.childNodes)
      };
    }
  },
  serialize: function serialize(obj, children) {
    if (obj.object == 'mark') {
      switch (obj.type) {
        case 'bold':
          return React.createElement(
            'strong',
            null,
            children
          );
        case 'italic':
          return React.createElement(
            'em',
            null,
            children
          );
        case 'delete':
          return React.createElement(
            'del',
            null,
            children
          );
        case 'underline':
          return React.createElement(
            'u',
            null,
            children
          );
        case 'code':
          return React.createElement(
            'code',
            null,
            children
          );
      }
    }
  }
}];

export default rules;